import Button from 'components/button'
import Modal from 'components/modals'
import React from 'react'
import EulaBody from '../html/Eula'

type ModalProps = {
  isOpen: boolean
  onClose: () => void
}

const EulaModal = ({ isOpen, onClose }: ModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Modal.Header title="End User License Agreement" />
      <Modal.Content>
        <div className="max-h-96 overflow-y-scroll informational-html pr-4 break-words">
          <EulaBody />
        </div>
      </Modal.Content>
      <Modal.Footer className="flex">
        <Button className="ml-auto" onClick={onClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default EulaModal